/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Measurement } from './Measurement';
import {
    MeasurementFromJSON,
    MeasurementFromJSONTyped,
    MeasurementToJSON,
    MeasurementToJSONTyped,
} from './Measurement';

/**
 * Sensor data for a device.
 * @export
 * @interface SensorData
 */
export interface SensorData {
    /**
     * 
     * @type {string}
     * @memberof SensorData
     */
    deviceId: string;
    /**
     * 
     * @type {Array<Measurement>}
     * @memberof SensorData
     */
    measurements: Array<Measurement>;
}

/**
 * Check if a given object implements the SensorData interface.
 */
export function instanceOfSensorData(value: object): value is SensorData {
    if ((!('deviceId' in (value as Record<string, any>)) && !('device_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['deviceId'] === undefined && (value as Record<string, any>)['device_id'] === undefined)) return false;
    if (!('measurements' in value) || value['measurements'] === undefined) return false;
    return true;
}

export function SensorDataFromJSON(json: any): SensorData {
    return SensorDataFromJSONTyped(json, false);
}

export function SensorDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SensorData {
    if (json == null) {
        return json;
    }
    return {
        
        'deviceId': json['device_id'],
        'measurements': ((json['measurements'] as Array<any>).map(MeasurementFromJSON)),
    };
}

export function SensorDataToJSON(json: any): SensorData {
    return SensorDataToJSONTyped(json, false);
}

export function SensorDataToJSONTyped(value?: SensorData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'device_id': value['deviceId'],
        'measurements': ((value['measurements'] as Array<any>).map(MeasurementToJSON)),
    };
}

